export const productsMap = {
    hotels: ['accommodation'],
    ATTSanatoria: ['accommodation'],
    transfers: ['transfer'],
    activities: ['excursion'],
    flights: ['flight', 'ownCharter'],
    packages: ['dynamicTour'],
    tours: ['customComplexTour'],
    carsRent: ['carRent'],
    visa: ['ownVisa'],
    tour: ['tour'],
    extraServices: ['ownExtraService'],
    conferenceHall: ['ownExtraService'],
    catering: ['ownExtraService'],
    insurance: ['insurance'],
    cruises: ['cruise'],
    multiDayTours: ['customComplexTour'],
    cruiseAsTrain: ['cruise'],
}

export const activeProducts = (activeProducts, availableProducts) =>
    availableProducts.length
        ? activeProducts.reduce((activeProducts, product) => {
              const mappedProducts = productsMap[product] || []
              if (mappedProducts.some(mappedProduct => availableProducts.includes(mappedProduct))) {
                  activeProducts.push(product)
              }
              return activeProducts
          }, [])
        : activeProducts

export const getMappedProductKeys = (activeProducts, availableProducts) => {
    if (!availableProducts.length) return []

    const activeMapped = activeProducts.reduce((result, product) => {
        const mappedProducts = productsMap[product] || []
        mappedProducts.forEach(mp => {
            if (availableProducts.includes(mp) && !result.includes(mp)) {
                result.push(mp)
            }
        })
        return result
    }, [])

    const additionalProducts = availableProducts.filter(ap => !activeMapped.includes(ap))

    return [...activeMapped, ...additionalProducts]
}
